import { useOutletContext } from "react-router";

import Box from "ds/components/Box";

import { ScanResourcesOutletContext } from "../../types";
import styles from "./styles.module.css";
import ScanResourcesSummaryTile from "./Tile";

const ScanResourcesSummary = () => {
  const { run } = useOutletContext<ScanResourcesOutletContext>();

  if (!run?.resourceCount) {
    return null;
  }

  return (
    <Box direction="row" fullWidth surfaceColor="primary" className={styles.bar}>
      <ScanResourcesSummaryTile
        title="Total resources"
        value={run.resourceCount}
        infoTooltip="All resources this scan run discovered."
        withDivider
      />
      <ScanResourcesSummaryTile
        title="Managed resources"
        value={run.resourceStats.managed}
        infoTooltip="Resources already accounted for by the state of a Spacelift stack."
        withDivider
      />
      <ScanResourcesSummaryTile
        title="Unmanaged resources"
        value={run.resourceStats.unmanaged}
        valueColor="warning"
        infoTooltip="Resources running outside of Spacelift's management."
      />
    </Box>
  );
};

export default ScanResourcesSummary;
